import { createJSONStorage, PersistStorage } from 'zustand/middleware'

const isLocalStorageAvailable = () => {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    localStorage.setItem('_localstorage', '')
    localStorage.removeItem('_localstorage')
    return true
  } catch (e) {
    return false
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const storage: PersistStorage<any> | undefined = createJSONStorage(() =>
  isLocalStorageAvailable()
    ? window.localStorage
    : {
        getItem: () => null,
        removeItem: () => {
          /**/
        },
        setItem: () => {
          /**/
        },
      },
)
